import React from 'react';

import { BiX } from 'react-icons/bi';
import { IoIosWarning } from 'react-icons/io';

import useNewOrder from './useNewOrder';

import * as S from './styles';

import Button from '../../newComponents/Button';
import ProductModal from './components/ModalProduct';

import CreateUserModal from './components/ModalCreateUser';
import ProductEditModal from './components/ModalProductEdit';
import Aside from './components/Aside';
import { MainFinish } from './components/MainFinish';
import MainProducts from './components/MainProducts';
import ModalPagBankPix from './components/ModalPagBankPix';
import { clearCurrentOrder } from '../../utils/clearCurrentOrder';

export default function NewOrder(): JSX.Element {
  const {
    asideIsClosed,
    asideIsOpen,
    cart,
    colorsAndSizesAll,
    deliveryFee,
    discountOnTheOutside,
    finalPrice,
    history,
    modalCancelRef,
    modalCreateUserRef,
    observation,
    selectedDeliveryType,
    selectedClient,
    selectedAddress,
    selectedCoupon,
    seletedProductId,
    selectdePaymentMethod,
    scheduledDelivery,
    seletedEditCartItemId,
    selectedCompanyId,
    step,
    theme,
    distances,
    isLoading,
    companies,
    pagbankPixOpen,
    pagbankPixCharge,
    closePagbankPix,
    handleChangeSelectedCompany,
    setIsLoading,
    addItemToCart,
    editItemToCart,
    handleFinalizeOrder,
    nextStep,
    prevStep,
    removeItemToCart,
    setAsideisClosed,
    setAsideIsOpen,
    setObservation,
    setDeliveryType,
    setSeletedEditCartItemId,
    setSelectedPaymentMethod,
    setSeletedProductId,
    setSelectedCoupon,
    setSelectedAddress,
    setSelectedClient,
    setScheduledDelivery,
    setDiscountOnTheOutside,
  } = useNewOrder();

  return (
    <S.Container asideIsClosed={asideIsClosed} asideIsOpen={asideIsOpen}>
      {step === 0 ? (
        <MainProducts
          cart={cart}
          setSeletedProductId={setSeletedProductId}
          selectedClient={selectedClient}
          setAsideisClosed={setAsideisClosed}
          finalPrice={finalPrice}
        />
      ) : null}
      {step === 1 ? (
        <MainFinish
          setSelectedCompanyId={handleChangeSelectedCompany}
          isEditing={false}
          distances={distances}
          companies={companies}
          selectedCompanyId={selectedCompanyId}
          isLoading={isLoading}
          cart={cart}
          finalPrice={finalPrice}
          observation={observation}
          prevStep={prevStep}
          selectedClient={selectedClient}
          scheduledDelivery={scheduledDelivery}
          selectedCoupon={selectedCoupon}
          selectedPaymentMethod={selectdePaymentMethod}
          setDiscountOnTheOutside={setDiscountOnTheOutside}
          setObservation={setObservation}
          setScheduledDelivery={setScheduledDelivery}
          setSelectedCoupon={setSelectedCoupon}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          discountOnTheOutside={discountOnTheOutside}
          handleFinalizeOrder={handleFinalizeOrder}
        />
      ) : null}
      <Aside
        cart={cart}
        selectedCompanyId={selectedCompanyId}
        deliveryFee={deliveryFee}
        finalPrice={finalPrice}
        removeItemToCart={removeItemToCart}
        selectedAddress={selectedAddress}
        selectedClient={selectedClient}
        selectedCoupon={selectedCoupon}
        selectedDeliveryType={selectedDeliveryType}
        setDeliveryType={setDeliveryType}
        setModalCancelIsOpen={() => modalCancelRef.current?.open()}
        nextStep={nextStep}
        setSelectedAddress={setSelectedAddress}
        setSelectedClient={setSelectedClient}
        setSeletedEditCartItemId={setSeletedEditCartItemId}
        discountOnTheOutside={discountOnTheOutside}
        handleFinalizeOrder={handleFinalizeOrder}
        step={step}
        selectdePaymentMethod={selectdePaymentMethod}
        setAsideisClosed={setAsideisClosed}
        modalCreateUserRef={modalCreateUserRef}
      />
      {/*  */}
      <S.CustomModalV2
        ref={modalCancelRef}
        containerStyle={{ zIndex: 99999999 }}
      >
        <S.ModalHeader>
          <div>
            <IoIosWarning />
          </div>
          <h1>Atenção</h1>
          <button type="button" onClick={() => modalCancelRef.current?.close()}>
            <BiX />
          </button>
        </S.ModalHeader>
        <p>
          Você não salvou suas alterações. Ao realizar a ação todos os dados
          serão perdidos.
          <br />
          <strong>Deseja prosseguir?</strong>
        </p>
        <Button
          full
          onClick={() => {
            clearCurrentOrder();
            history.push('/monitor_pedidos');
          }}
        >
          Confirmar
        </Button>
        <Button
          full
          variant="outlined"
          onClick={() => modalCancelRef.current?.close()}
        >
          Cancelar
        </Button>
      </S.CustomModalV2>

      <ProductModal
        isOpen={!!seletedProductId}
        productId={seletedProductId}
        onClose={() => setSeletedProductId(null)}
        addItemToCart={addItemToCart}
        colorsAndSizesAll={colorsAndSizesAll}
      />

      <ModalPagBankPix
        isOpen={pagbankPixOpen}
        charge={pagbankPixCharge}
        isWaiting={pagbankPixOpen}
        onClose={closePagbankPix}
      />

      <ProductEditModal
        isOpen={seletedEditCartItemId !== null}
        seletedEditProductId={
          cart?.find((item) => item.id === seletedEditCartItemId)
            ?.compositeProduct.product.id || null
        }
        onClose={() => setSeletedEditCartItemId(null)}
        editItemToCart={(payload) =>
          editItemToCart(seletedEditCartItemId!, payload)
        }
        cartItem={cart.find((item) => item.id === seletedEditCartItemId)}
        colorsAndSizesAll={colorsAndSizesAll}
      />
    </S.Container>
  );
}
